// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-container {
  display: flex;
  align-items: center;
  background: var(--indigo);
  padding-left: 14%;
  justify-content: space-between;
  height: 56px;
}
.navbar-container img {
  width: 162px;
}
.user-profile {
  background: transparent;
  border: none;
  outline: none;
  display: flex;
  gap: 10px;
  justify-self: center;
  align-items: center;
  color: var(--white);
  margin-right: 15%;
  position: relative;
}
.user-profile .profile-icon {
  width: 28px;
  border-radius: 50%;
}
.user-profile .down-arrow {
  width: 16px;
}
.user-profile p {
  margin-right: 8px;
}
.user-profile .option-list {
  position: absolute;
}
.user-profile ul {
  top: 33px;
  box-shadow: 0px 4px 4px 0px #0000001a;
  margin: 0;
  padding: 12px 0;
  color: #000;
  list-style-type: none;
  background: #fefdfe;
  border-radius: 6px;
  min-width: 90px;
  left: 38px;
  text-align: left;
}
.user-profile li {
  padding: 0px 12px;
  height: 30px;
  align-items: center;
  display: flex;
}
.user-profile li:hover {
  background: var(--grey);
}
`, "",{"version":3,"sources":["webpack://./src/components/navBar/navBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".navbar-container {\n  display: flex;\n  align-items: center;\n  background: var(--indigo);\n  padding-left: 14%;\n  justify-content: space-between;\n  height: 56px;\n}\n.navbar-container img {\n  width: 162px;\n}\n.user-profile {\n  background: transparent;\n  border: none;\n  outline: none;\n  display: flex;\n  gap: 10px;\n  justify-self: center;\n  align-items: center;\n  color: var(--white);\n  margin-right: 15%;\n  position: relative;\n}\n.user-profile .profile-icon {\n  width: 28px;\n  border-radius: 50%;\n}\n.user-profile .down-arrow {\n  width: 16px;\n}\n.user-profile p {\n  margin-right: 8px;\n}\n.user-profile .option-list {\n  position: absolute;\n}\n.user-profile ul {\n  top: 33px;\n  box-shadow: 0px 4px 4px 0px #0000001a;\n  margin: 0;\n  padding: 12px 0;\n  color: #000;\n  list-style-type: none;\n  background: #fefdfe;\n  border-radius: 6px;\n  min-width: 90px;\n  left: 38px;\n  text-align: left;\n}\n.user-profile li {\n  padding: 0px 12px;\n  height: 30px;\n  align-items: center;\n  display: flex;\n}\n.user-profile li:hover {\n  background: var(--grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
